(() => {
  // Wishlist Engine omits Shopify template metadata, so query the lightweight
  // product.wishlist-status view before replacing a rendered product price.
  const containerSelector = '#wishlist-page-contain'
  const cardSelector = '.wh-list-column'
  const priceSelector = '.wishlist-price'
  const productLinkSelector = '.wh-list-left a[href*="/products/"]'
  const statusRequests = new Map()

  const getProductHandle = (card) => {
    const link = card.querySelector(productLinkSelector)
    if (!link) return null

    const url = new URL(link.href, window.location.origin)
    const productPath = url.pathname.split('/products/')[1]
    return productPath ? decodeURIComponent(productPath.split('/')[0]) : null
  }

  const getInquireStatus = (handle) => {
    if (statusRequests.has(handle)) return statusRequests.get(handle)

    const root = window.Shopify?.routes?.root || '/'
    const statusUrl = `${root}products/${encodeURIComponent(handle)}?view=wishlist-status`
    // Shopify's application/json response bypasses alternate Liquid views.
    const request = fetch(statusUrl, { cache: 'no-store', headers: { Accept: 'text/html' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Wishlist product status request failed: ${response.status}`)
        return response.json()
      })
      .then((status) => status.isInquire === true)
      .catch((error) => {
        statusRequests.delete(handle)
        throw error
      })

    statusRequests.set(handle, request)
    return request
  }

  const renderInquirePrice = (card) => {
    const price = card.querySelector(priceSelector)
    if (!price) return

    price.classList.add('wishlist-price--inquire')
    price.setAttribute('aria-label', 'Inquire')

    if (!price.querySelector('.wishlist-inquire-label')) {
      const label = document.createElement('span')
      label.className = 'wishlist-inquire-label'
      label.textContent = 'Inquire'
      price.append(label)
    }
  }

  const processCard = async (card) => {
    if (card.dataset.inquireStatus === 'true') {
      renderInquirePrice(card)
      return
    }

    if (card.dataset.inquireStatus === 'false' || card.dataset.inquireStatus === 'loading') return

    const handle = getProductHandle(card)
    if (!handle) return

    card.dataset.inquireStatus = 'loading'

    try {
      const isInquire = await getInquireStatus(handle)
      card.dataset.inquireStatus = String(isInquire)
      if (isInquire) renderInquirePrice(card)
    } catch (error) {
      delete card.dataset.inquireStatus
      console.warn(error)
    }
  }

  const processCards = (container) => {
    container.querySelectorAll(cardSelector).forEach((card) => processCard(card))
  }

  const initializeWishlist = () => {
    const container = document.querySelector(containerSelector)
    if (!container || container.dataset.inquirePricesInitialized === 'true') return

    container.dataset.inquirePricesInitialized = 'true'
    processCards(container)

    const observer = new MutationObserver(() => processCards(container))
    observer.observe(container, { childList: true, subtree: true, characterData: true })
  }

  document.addEventListener('wishlist:page:loaded', initializeWishlist)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWishlist)
  } else {
    initializeWishlist()
  }
})()
